import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import channels from '@/page/channels'
import broadcast from '@/page/broadcast'
import digitalcontent from '@/page/digitalcontent'
import kols from '@/page/kols'
import nba from '@/page/nba'
import games from '@/page/games'
import read from '@/page/read'
import us from '@/page/us'
import news from '@/page/news'
import newsdetail from '@/page/newsdetail'
import contact from '@/page/contact'
import welfare from '@/page/welfare'
import welfaredetail from '@/page/welfaredetail'
import join from '@/page/join'
import jobs from '@/page/jobs'
import jobsdetail from '@/page/jobsdetail'
import resume from '@/page/resume'
import nbaip from '@/page/NBAIP'

Vue.use(Router)


export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home
    },
    {
      path: '/channel',
      name: '信息流广告',
      component: channels
    },
    {
      path: '/broadcast',
      name: '带货电商',
      component: broadcast
    },
    {
      path: '/digitalcontent',
      name: '数字内容',
      component: digitalcontent
    },
    {
      path: '/kol',
      name: '游戏数字传播',
      component: kols
    },
    {
      path: '/nba',
      name: 'NBA数字传播',
      component: nba
    },
    {
      path: '/game',
      name: '游戏发行',
      component: games
    },
    {
      path: '/read',
      name: '内容出版',
      component: read
    },
    {
      path: '/about',
      name: '关于我们',
      component: us
    },
    {
      path: '/news',
      name: '新闻资讯',
      component: news
    },
    {
      path: '/newsdetail/:newsid',
      name: '新闻资讯详情',
      component: newsdetail
    },
    {
      path: '/contact',
      name: '联系我们',
      component: contact
    },
    {
      path: '/welfare',
      name: '社会公益',
      component: welfare
    },
    {
      path: '/welfaredetail/:id',
      name: '社会公益详情',
      component: welfaredetail
    },
    {
      path: '/join',
      name: '加入我们',
      component: join
    },
    {
      path: '/join/:typeid',
      name: '招聘列表',
      component: jobs
    },
    {
      path: '/jobsdetail/:jobsid',
      name: '招聘详情',
      component: jobsdetail
    },
    {
      path: '/resume',
      name: '简历投递',
      component: resume
    },
    {
      path: '/nbaip',
      name: 'NBA IP联名',
      component: nbaip
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }
    return {x: 0, y: 0}
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js